import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import {
  StyledActionSectionTitle,
  StyledActionsButtonContainer,
  StyledActionsContainer,
  StyledCtaButton,
} from '../../BookingInformation.styles';

interface BookingTenantActionsProps {
  booking_id: string;
  user_type: 'tenant' | 'landlord';
  canShowUploadButton: boolean;
}

const BookingTenantActions = ({
  booking_id,
  user_type,
  canShowUploadButton,
}: BookingTenantActionsProps) => {
  const { locale } = useParams();
  const { t } = useTranslation(['booking', 'form']);
  const navigate = useNavigate();
  const redirectToUploadDocuments = () => {
    navigate(
      `/${locale}/${t('navigation:attach_documents')}?booking_id=${booking_id}`,
    );
  };
  return (
    <StyledActionsContainer>
      <StyledActionSectionTitle>
        {upperFirst(t('booking:availableActions'))}
      </StyledActionSectionTitle>
      <StyledActionsButtonContainer>
        {canShowUploadButton && (
          <StyledCtaButton
            user={user_type}
            variant="primary"
            wideOnMobile={true}
            onClick={redirectToUploadDocuments}
          >
            {upperFirst(t('booking:uploadDocuments'))}
          </StyledCtaButton>
        )}
        <br />
      </StyledActionsButtonContainer>
    </StyledActionsContainer>
  );
};

export default BookingTenantActions;
